import React from 'react';

import { ButtonV2, Row, Rows, Text, TextButton } from '~/src/dash/publicaUI';
import { publicaColors } from '~/src/dash/utils/colors';

export const ButtonsDemo = () => {
  return (
    <Rows>
      <Row style={{ backgroundColor: publicaColors.lightGray }}>
        <Text subheader>Buttons</Text>
        <Text small muted>
          ButtonV2, TextButton
        </Text>
      </Row>
      <Row>
        <ButtonV2 onClick={() => null}>ButtonV2</ButtonV2>
      </Row>
      <Row>
        <ButtonV2 large onClick={() => null}>
          ButtonV2 large
        </ButtonV2>
      </Row>
      <Row>
        <ButtonV2 disabled onClick={() => null}>
          ButtonV2 disabled
        </ButtonV2>
      </Row>
      <Row>
        <TextButton onClick={() => null}>TextButton</TextButton>
      </Row>
      <Row>
        <TextButton disabled onClick={() => null}>
          TextButton disabled
        </TextButton>
      </Row>
      <Row height={16}></Row>
    </Rows>
  );
};
